import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackBannerShow, trackBannerClick } from './tracking';
import {
  selectNewbuildingBrokerConsultantBannerUrl,
  selectNewbuildingBrokerConsultantBannerButtonText,
  selectNewbuildingBrokerFlightEnabled,
} from 'shared/selectors/newbuildingBrokerConsultantBanner';
import { selectJsonQuery } from 'shared/selectors/results';
import { NewbuildingBrokerConsultantBanner } from 'shared/serp/components/NewbuildingBrokerConsultantBanner';
import { NewbuildingBrokerFlightBanner } from 'shared/serp/components/NewbuildingBrokerFlightBanner';

export const NewbuildingBrokerConsultantBannerContainer: React.FC = () => {
  const url = useSelector(selectNewbuildingBrokerConsultantBannerUrl) as string;
  const buttonText = useSelector(selectNewbuildingBrokerConsultantBannerButtonText);
  const isBrokerFlightEnabled = useSelector(selectNewbuildingBrokerFlightEnabled);

  const jsonQuery = useSelector(selectJsonQuery);

  const onShow = React.useCallback(() => {
    trackBannerShow(jsonQuery);
  }, [jsonQuery]);

  const onClick = React.useCallback(() => {
    trackBannerClick(jsonQuery);
  }, [jsonQuery]);

  // TODO: Удалить в CD-251392.
  if (isBrokerFlightEnabled) {
    return (
      <ActionAfterViewObserver callback={onShow} percentVisible={0.8} triggerOnce>
        <NewbuildingBrokerFlightBanner url={url} buttonText={buttonText} onClick={onClick} />
      </ActionAfterViewObserver>
    );
  }

  return (
    <ActionAfterViewObserver callback={onShow} percentVisible={0.8} triggerOnce>
      <NewbuildingBrokerConsultantBanner url={url} buttonText={buttonText} onClick={onClick} />
    </ActionAfterViewObserver>
  );
};
